export const FETCH_TABLE_COLUMNS_SUCCESS = "FETCH_DB_COLUMNS_SUCCESS";
export const FETCH_TABLE_COLUMNS_FAILED = "FETCH_DB_COLUMNS_FAILED";
